import React, {FC, useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';
import {Colors, Tooltip} from '@optimaxdev/design-system';

import {Icon, ShareIos} from '@optimaxdev/icons';

import {CART_BUTTON} from 'constants/analytics/events/cart';
import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

import {ShareCartModal} from '../shareCartModal/shareCartModal';

import s from './shareCartTooltipButton.scss';

export type PropsType = {
    count: number;
};
/**
 * Displays share cart tooltip button
 * @params {PropsType} props - component props
 * @returns {ReactElement} component for share cart tooltip button
 */
export const ShareCartTooltipButton: FC<PropsType> = ({count}) => {
    const [shareCartModalVisible, setShareCartModalVisible] = useState(false);

    const handleShareIconClick = () => {
        setShareCartModalVisible(true);

        spawnPriorityTask(() =>
            sendDesktopAnalyticsEvent(CART_BUTTON, {
                action: 'Navigation',
                label: 'Share - Clicked',
            }),
        );
    };

    return (
        <>
            <div className={s.shareBlock}>
                <p className={s.count}>
                    (<span data-test-name="cartItemsCount">{count}</span>)
                </p>
                <div className={s.tooltipIcon}>
                    <Tooltip
                        closeTrigger="hover"
                        content={<p className={s.tooltipContent}>Share Cart</p>}
                        openDelay={0}
                        openTrigger="hover"
                        position="bottom"
                        renderAs="div"
                        size="small"
                        tooltipAnimation="fastMoving"
                    >
                        <button
                            aria-label="Share Cart"
                            onClick={handleShareIconClick}
                            type="button"
                        >
                            <Icon
                                color={Colors.limedSpruce}
                                cursor="pointer"
                                height={20}
                                icon={ShareIos}
                                label="Share Cart Icon"
                                strokeWidth={2}
                                width={16}
                            />
                        </button>
                    </Tooltip>
                </div>
            </div>
            <ShareCartModal
                closePopup={() => setShareCartModalVisible(false)}
                isVisible={shareCartModalVisible}
            />
        </>
    );
};
